export const THEME_PRESETS = {
    light: require('./palettes/light.module.scss'),
    dark: require('./palettes/dark.module.scss'),
    warm: require('./palettes/warm.module.scss'),
    relax: require('./palettes/relax.module.scss')
};
